import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Header = styled.header`
  position: relative;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLORS.white};
  box-shadow: 0 4px 7px 0 #5690ff1c;
  flex-shrink: 0;
  padding: 0 20px;
  box-sizing: border-box;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding: 0 10px 0 20px;
  }
`

export const LeftBlock = styled.div`
  display: flex;
  align-items: center;
`

export const RightBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const Separator = styled.div<{ $hideOnMobile?: boolean }>`
  width: 1px;
  height: 20px;
  background-color: ${COLORS.borderColor};
  margin: 0 16px;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    display: ${({ $hideOnMobile }) => ($hideOnMobile ? 'none' : 'block')};
    margin: 0 10px;
  }
`
